{
  "chart": {
    "header": "Ramverk",
    "otherLinkedDocuments": "Övriga länkade dokument",
    "hideCategories": "Dölj kategorier",
    "groupByGraphs": "Gruppera efter grafer",
    "includeDrafts": "Inkludera icke publicerade dokument",
    "noDraftsToInclude": "Inga icke publicerade dokument tillgängliga att inkludera",
    "sharedFrom": "Delad från {{unit}}"
  }
}
